import React, { FC } from 'react'
import { Link, useParams } from 'react-router-dom'
import styles from './Menu.module.scss'
import { useCatalog } from 'context/catalog/CatalogContext'

export interface IMenuProps {
    //propertys
    onClickOut?: () => void
    onClickLogin?: () => void
    onClickDeleteAccount?: () => void
}
const Menu: FC<IMenuProps> = ({ onClickOut, onClickLogin, onClickDeleteAccount}) => {
    const { storeId, url } = useParams<{ storeId: string; url: string }>();
    const { catalog } = useCatalog();

    return (
        <div id={styles.Menu} >
            <div className={styles.menu}>
                <ul>
                    {url && <Link to={`/${url}`}><li>Início</li></Link>}
                    {url && storeId && <Link to={`/${url}/${storeId}`}><li>Cardápio</li></Link>}
                    {catalog?.enableShoppingCart !== false && (
                    <Link to={"/pedidos"}><li>Pedidos</li></Link>
                    )}
                    {/* <Link to={"/"+url +"/schedule/tour/reserves"}><li>Reservas</li></Link> */}
                    {onClickLogin && <li onClick={onClickLogin}>Entrar</li>}
                    {onClickOut && <li onClick={onClickOut}>Sair</li>}
                    {onClickDeleteAccount && <li style={{color: "red"}} onClick={onClickDeleteAccount}>Excluir minha conta</li>}              
                </ul>
            </div>
            <div className={styles.menuFaq}>
                {/* <img src={Help} alt="Logo de ajuda"/>
                <ul>         
                    <Link to={"/"+url +"/schedule/tour/faq"}><li>Ajuda</li></Link>
                </ul> */}
            </div>
        </div>
    )
}
export default Menu